<ng-container *ngrxLet="signUpStatus$; let signUpStatus">
    <div class="container h-100 pt-5 font-small">
        <div class="col-8 offset-2 h-100 justify-content-center align-items-center">
            <div class="d-flex flex-column form-container rounded-top">
                <div class="d-flex flex-column pb-3">
                    <div class="p-0 p-sm-5 d-flex flex-column">
                        <ng-container *ngIf="customizations$ | async as customizations">
                            <div class="d-flex justify-content-center">
                                <p-image src="{{ 'data:image/png;base64,' + customizations.logoData }}" alt="Logo" *ngIf="!!customizations.logoData"></p-image>
                                <p-image src="../../assets/image/sf-fitness-logo_login.png" alt="Logo" width="250" *ngIf="!customizations.logoData"></p-image>
                            </div>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="signUpStatus !== 'ok'">
                        <div class="mr-3 ml-3" *ngIf="signUpStatus !== null && signUpStatus !== 'ok'">
                            <div class="alert alert-danger" role="alert">
                                {{ signUpStatus }}
                            </div>
                        </div>
                        <div class="mr-3 ml-3" [formGroup]="signUpForm">
                            <div class="form-group">
                                <label for="gender">{{ 'AUTHENTICATION.SIGN_UP.FORM_TITLE' | translate }} *</label>
                                <select class="form-control" id="gender" formControlName="gender">
                                    <option value="" selected>{{ 'CORE_CHOOSE_TITLE' | translate }}</option>
                                    <option value="FEMALE">{{ 'CORE_GENDER_FEMALE' | translate }}</option>
                                    <option value="MALE">{{ 'CORE_GENDER_MALE' | translate }}</option>
                                </select>
                                <div *ngIf="gender?.invalid && (gender?.dirty || gender?.touched)" class="text-danger pt-1">
                                    <div *ngIf="gender?.errors?.['required'] || gender?.errors?.['valueSelected']">{{ 'VALIDATION_ANGUCOMPLETE_REQUIRED' | translate }}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="firstName">{{ 'AUTHENTICATION.SIGN_UP.FIRST_NAME' | translate }} *</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="firstName"
                                            placeholder="{{ 'AUTHENTICATION.SIGN_UP.FIRST_NAME' | translate }}"
                                            formControlName="firstName"
                                        />
                                        <div *ngIf="firstName?.invalid && (firstName?.dirty || firstName?.touched)" class="text-danger pt-1">
                                            <div *ngIf="firstName?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="lastName">{{ 'AUTHENTICATION.SIGN_UP.LAST_NAME' | translate }} *</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="lastName"
                                            placeholder="{{ 'AUTHENTICATION.SIGN_UP.LAST_NAME' | translate }}"
                                            formControlName="lastName"
                                        />
                                        <div *ngIf="lastName?.invalid && (lastName?.dirty || lastName?.touched)" class="text-danger pt-1">
                                            <div *ngIf="lastName?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="username">{{ 'AUTHENTICATION.SIGN_UP.USER_NAME' | translate }} *</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="username"
                                            placeholder="{{ 'AUTHENTICATION.SIGN_UP.USER_NAME' | translate }}"
                                            formControlName="userName"
                                        />
                                        <div *ngIf="userName?.invalid && (userName?.dirty || userName?.touched)" class="text-danger pt-1">
                                            <div *ngIf="userName?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                                            <div *ngIf="userName?.errors?.['userNameExists']">{{ userName?.errors?.['userNameExists'] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        <label for="email">E-Mail *</label>
                                        <input type="email" class="form-control" id="email" placeholder="E-Mail" formControlName="email" />
                                        <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="text-danger pt-1">
                                            <div *ngIf="email?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                                            <div *ngIf="email?.errors?.['email']">{{ 'VALIDATION_EMAIL' | translate }}</div>
                                            <div *ngIf="email?.errors?.['emailExists']">{{ email?.errors?.['emailExists'] }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="password">{{ 'AUTHENTICATION.PASSWORD' | translate }}</label>
                                <input type="password" class="form-control" id="password" placeholder="{{ 'AUTHENTICATION.PASSWORD' | translate }}" formControlName="password" />
                                <div *ngIf="password?.invalid && (password?.dirty || password?.touched)" class="text-danger pt-1">
                                    <div *ngIf="password?.errors?.['required']">{{ 'VALIDATION_REQUIRED' | translate }}</div>
                                </div>
                                <app-password-strength inputFormControlName="password"></app-password-strength>
                            </div>
                            <div class="form-group">
                                <label for="passwordConfirm">{{ 'AUTHENTICATION.SIGN_UP.PASSWORD_CONFIRM' | translate }}</label>
                                <input
                                    [class.ng-invalid]="signUpForm.errors?.['PasswordNoMatch']"
                                    type="password"
                                    class="form-control"
                                    id="passwordConfirm"
                                    placeholder="{{ 'AUTHENTICATION.SIGN_UP.PASSWORD_CONFIRM' | translate }}"
                                    formControlName="passwordConfirm"
                                />
                                <div class="text-danger pt-1" *ngIf="signUpForm.errors?.['PasswordNoMatch'] && passwordConfirm?.touched">
                                    {{ 'AUTHENTICATION.SIGN_UP.PASSWORD_NOT_EQUAL' | translate }}
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="d-flex flex-row">
                                    <div class="d-flex align-items-center">
                                        <input type="checkbox" formControlName="isAgbAccepted" />
                                    </div>
                                    <div class="d-flex align-items-center pl-2" [innerHTML]="'SYSTEM.AGB_ACCEPT' | translate"></div>
                                </div>
                            </div>
                            <button class="btn btn-primary btn-block" (click)="signUp()" [disabled]="!isAgbAccepted?.value">
                                {{ 'AUTHENTICATION.SIGN_UP.BUTTON_CREATE_ACCOUNT' | translate }}
                            </button>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="signUpStatus === 'ok'">
                        <div class="w-100 d-flex justify-content-center font-weight-bold">
                            {{ 'AUTHENTICATION.SIGN_UP.COMPLETE_TITLE' | translate }}
                        </div>
                        <div class="mr-3 ml-3 mt-2 w-100 d-flex">
                            {{ 'AUTHENTICATION.SIGN_UP.COMPLETE_INFO' | translate }}
                        </div>
                    </ng-container>
                </div>
                <ng-container *ngIf="signUpStatus !== 'ok'">
                    <div class="form-group d-flex w-100 p-2 sign-link">
                        <a routerLink="/auth/sign-in">
                            <small class="form-text"> {{ 'AUTHENTICATION.SIGN_UP.ALREADY_ACCOUNT_REQUEST' | translate }}</small>
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="signUpStatus === 'ok'">
                    <div class="form-group d-flex w-100 p-2 sign-link">
                        <a routerLink="/auth/sign-in">
                            <small class="form-text"> {{ 'AUTHENTICATION.BUTTON_BACK_TO_LOGIN' | translate }}</small>
                        </a>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
